import React, { useEffect, useState } from "react";
import { X, Mail } from "lucide-react";
import { NewsletterForm } from "./NewsletterForm";

const DISMISSED_KEY = "fitsme.newsletter_banner_dismissed_v1";

export const NewsletterBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const dismissed = localStorage.getItem(DISMISSED_KEY);
        if (dismissed) return;
        // Slight delay so it doesn't compete with the hero LCP
        const t = setTimeout(() => setVisible(true), 1800);
        return () => clearTimeout(t);
    }, []);

    const dismiss = () => {
        localStorage.setItem(DISMISSED_KEY, new Date().toISOString());
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="newsletter-banner"
            className="fixed bottom-4 inset-x-3 sm:inset-x-auto sm:right-6 sm:bottom-6 z-40 max-w-md mx-auto sm:mx-0"
        >
            <div className="relative border-4 border-[#CCFF00] bg-black text-[#CCFF00] p-4 sm:p-5 shadow-[8px_8px_0_#FF00FF]">
                <button
                    onClick={dismiss}
                    data-testid="newsletter-banner-dismiss"
                    aria-label="Dismiss"
                    className="absolute -top-3 -right-3 w-8 h-8 border-2 border-black bg-[#FF00FF] text-white flex items-center justify-center shadow-brutal-sm"
                >
                    <X className="w-4 h-4" />
                </button>
                <div className="flex items-start gap-3">
                    <Mail className="w-5 h-5 mt-1 shrink-0" />
                    <div className="min-w-0">
                        <p className="font-mono text-[10px] uppercase tracking-widest text-[#CCFF00]/70">/ Friday Drops · No spam /</p>
                        <h3 className="font-display text-xl sm:text-2xl font-black uppercase tracking-tight leading-none mt-1">
                            The weekly drop, in your inbox.
                        </h3>
                        <p className="font-mono text-[11px] mt-2 text-[#CCFF00]/80">
                            Picks sized for you. Unsubscribe one click.
                        </p>
                        <div className="mt-3">
                            <NewsletterForm variant="banner" source="home-banner" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
